import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    ASSIGNEE,
    SAVE_TASK,
    UPDATE_TASK,
    REMOVE_TASK,
    OPPORTUNITY_DETAILS,
    ACCOUNT_DETAILS,
    TASK_TYPES,
    TASK_BY_ID,
    TASK_LISTING, TASK_FILTER
} from "./type";


export const getAssignee = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.fetchReportee}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ASSIGNEE,
            payload: data.response,
        });
        return true;
    }
};

export const getAccount = (assigned_to) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.accountDetailsForTask}?assigned_to=`+assigned_to
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ACCOUNT_DETAILS,
            payload: data.response,
        });
        return true;
    }
};

export const getOpportunityByAccountId = (accountId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.opportunityList}?account_id=${accountId}&is_task=`+true
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: OPPORTUNITY_DETAILS,
            payload: data.response,
        });
        return true;
    }
};

export const saveTask = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.saveTask}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_TASK,
            payload: data.response,
        });
        return true;
    }
};

export const getTaskTypes = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.taskTypes}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TASK_TYPES,
            payload: data.response,
        });
        return true;
    }
};

export const updateTask = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.updateTask}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: UPDATE_TASK,
            payload: data.response,
        });
        return true;
    }
};

export const removeTask = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.removeTask}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: REMOVE_TASK,
            payload: data.response,
        });
        return true;
    }
};

export const getTaskById = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.taskById}?id=`+id
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TASK_BY_ID,
            payload: data.response.data,
        });
        return true;
    }
};


export const taskListing = (page = 1, type, filterInputList =[{}]) => async (dispatch) => {
    let urls = `${Config.taskListing}?type=`+type+"&page="+page

    Object.keys(filterInputList[0]).map((val, i)=>{
        urls+="&"+val+"="+filterInputList[0][val]
    })

    const res = await callWebService(
        callTypes.get,
        '',
        urls
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TASK_LISTING,
            payload: data.response.data,
        });
        return true;
    }
};

export const taskFilter = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.taskFilter}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TASK_FILTER,
            payload: data.response,
        });
        return true;
    }
};


